
// $('#season-selector').val('all');
const HAS_CLIPBOARD = 'clipboard' in navigator && (typeof navigator.clipboard.writeText === 'function');
const HAS_EXEC_COMMAND = typeof document.execCommand === 'function';
const CAN_COPY = HAS_CLIPBOARD || HAS_EXEC_COMMAND;

var handleCopy = function(event) {
    if (!CAN_COPY) {
        return;
    }
    const button = event.target;
    const input = document.querySelector(button.dataset.copyTarget);

    if (!input || !input.value) {
        return;
    }

    input.focus();
    input.select();

    const done = () => {
        button.innerHTML = 'Copied';
        setTimeout(() => {
            try { button.innerHTML = COPY_TEXT; } catch(e) {}
        }, 2000);
    };

    if (HAS_CLIPBOARD) {
        navigator.clipboard.writeText(input.value).then(done).catch(() => {});
    } else if (HAS_EXEC_COMMAND) {
        if (document.execCommand('copy') === true) {
            done();
        }
    }
}

var audio = null;
window.onload = () => {
    // $('#season-selector').on('change',function(evt){
    //     if ($('#season-selector').val() === 'all') {
    //         for (var i = 1; i <= $('.season').length; i++) {
    //             $('#season-' + i).show();
    //         }
    //     }
    //     else {
    //         for (var i = 1; i <= $('.season').length; i++) {
    //             $('#season-' + i).hide();
    //         }
    //         $('#'+ $('#season-selector').val()).show();
    //     }
    // })

    if (CAN_COPY) {
        var copyButtons_ = document.querySelectorAll('.copy-button');
        copyButtons_.forEach(button => $(button).on('click', handleCopy));
    }

    $('.play').on('click touch', (evt) => {
        if (audio){
            audio.removeEventListener("timeupdate",window.listener);
        }
        $("#" + $(evt.currentTarget).data('audio'))[0].play();
        $('.play-button[data-audio='+$(evt.currentTarget).data('audio')+']').hide();
        $('.pause-button[data-audio='+$(evt.currentTarget).data('audio')+']').show();
        audio = $("#" + $(evt.currentTarget).data('audio'))[0];
        audio.play();
        window.listener = audio.addEventListener("timeupdate", (event) => {
            const { duration, currentTime } = audio;
            const position = (currentTime / duration) * 100;
            $('#progress-'+audio.id).width((position + '%'));

        })
    });

    $('.pause').on('click touch', (evt) => {
        $("#" + $(evt.currentTarget).data('audio'))[0].pause();
        $('.play-button[data-audio='+$(evt.currentTarget).data('audio')+']').show();
        $('.pause-button[data-audio='+$(evt.currentTarget).data('audio')+']').hide();
    });

    $('.skip-forward').on('click touch', (evt) => {
        if (audio && audio.id == $("#" + $(evt.currentTarget).data('audio'))[0].id)
            audio.currentTime = audio.currentTime + 15;
    });
    $('.skip-backward').on('click touch', (evt) => {
        if (audio && audio.id == $("#" + $(evt.currentTarget).data('audio'))[0].id)
            audio.currentTime = audio.currentTime - 15;
    });

    $('.share').on('click touch', (evt) => {
        var copyButtons_ = document.querySelectorAll('.copy-button');
        copyButtons_.forEach(button => $(button).html('COPY'));
        $(".as-share-overlay").css('display', 'flex');
        audio = $("#" + $(evt.currentTarget).data('audio'))[0];
        $("#embed-code-input").val('<iframe id="music-frame" src="https://as-embed-player.adultswim.com/?album=podcast&track='+ window.location.href.split('/')[4] + '-episode-' + audio.id + '" width="100%" height="400" frameborder="0"></iframe>');
        if (window.location.href.split('/').length === 6) {
            $("#direct-link-input").val(window.location.href)
            $('.facebook-icon a').attr('href','https://facebook.com/sharer.php?u='+window.location.href);
            $('.twitter-icon a').attr('href','https://twitter.com/intent/tweet?url='+window.location.href);
        }
        else {
            $("#direct-link-input").val(window.location.href + '/' + audio.id);
            $('.facebook-icon a').attr('href','https://facebook.com/sharer.php?u='+window.location.href + '/' + audio.id);
            $('.twitter-icon a').attr('href','https://twitter.com/intent/tweet?url='+window.location.href + '/' + audio.id);
        }
    });

    $('.close').on('click touch', (evt) => {
        $(".as-share-overlay").css('display', 'none');
    });
};

$('.progress-bar').click(e => {
    if (audio) {
        const { offsetX } = e.originalEvent || e.nativeEvent;
        const fullWidth = 350;
        if (audio) audio.currentTime = (offsetX / fullWidth) * audio.duration;
    }
});